import { useContext } from 'react';

import { AdjustInvoiceContext } from './adjustInvoiceContextProvider';

export default function useAdjustInvoiceContext() {
	const context = useContext(AdjustInvoiceContext);
	if (!context) {
		throw new Error('useAdjustInvoiceContext can only be used inside AdjustInvoiceContextProvider');
	}
	return context;
}
